import { paletteTheme } from "@configs/theme/custom/palette";

export const buttonTheme = {
  paddingBlockLG: 14,
  paddingInlineLG: 24,
  fontWeight: 500,
  paddingBlockSM: 12,
  paddingInlineSM: 24,
  paddingBlock: 8,
  paddingInline: 24,
  controlHeight: 44,
  controlHeightLG: 52,
  controlHeightSM: 36,
  borderRadiusLG: 10,
  borderRadiusSM: 10,
  defaultActiveBg: "rgba(255, 255, 255, 0)",
  defaultBg: "transparent",
  defaultBorderColor: paletteTheme.colorBorderSecondary,
  // colorBgContainerDisabled: paletteTheme.colorPrimaryHover,
  // colorTextDisabled: "#fff",
};
